<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            :name="field.fieldName"
            v-model="value"
            :items="field.list"
            item-text="text"
            item-value="value"
            @change="field.value = value"
        ></v-autocomplete>
    </ies-form-field>
</template>

<script>
    export default {
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                value: parseInt(this.field.oldValue),
            }
        },
    }
</script>
